import {Map, fromJS, List} from "immutable";

import {
    GET_WAREHOUSES_SUCCESS,
    GET_WAREHOUSES_REQUEST,
    GET_WAREHOUSES_ERROR,
    GET_WAREHOUSE_REQUEST,
    GET_WAREHOUSE_SUCCESS,
    GET_WAREHOUSE_ERROR,
    CREATE_WAREHOUSE_REQUEST,
    CREATE_WAREHOUSE_SUCCESS,
    CREATE_WAREHOUSE_ERROR,
    UPDATE_WAREHOUSE_REQUEST,
    UPDATE_WAREHOUSE_SUCCESS,
    UPDATE_WAREHOUSE_ERROR,
    CHANGE_STATUS_WAREHOUSE_REQUEST,
    CHANGE_STATUS_WAREHOUSE_SUCCESS,
    CHANGE_STATUS_WAREHOUSE_ERROR,
    DELETE_WAREHOUSE_REQUEST,
    DELETE_WAREHOUSE_SUCCESS,
    DELETE_WAREHOUSE_ERROR,
    CLEAN_WAREHOUSES
} from '../actions/warehouses';

const warehouses = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_WAREHOUSES_REQUEST:
      case GET_WAREHOUSE_REQUEST:
      case CREATE_WAREHOUSE_REQUEST:
      case UPDATE_WAREHOUSE_REQUEST:
      case CHANGE_STATUS_WAREHOUSE_REQUEST:
      case DELETE_WAREHOUSE_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_WAREHOUSES_SUCCESS:
      case GET_WAREHOUSE_SUCCESS:
      case CLEAN_WAREHOUSES:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_WAREHOUSE_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_WAREHOUSE_SUCCESS:
      case CHANGE_STATUS_WAREHOUSE_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {

              // Find the index of the warehouse to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });

              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }


              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;

      case DELETE_WAREHOUSE_SUCCESS:
          updatedPayload = payload.filter( warehouse => {
              return warehouse.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_WAREHOUSES_ERROR:
      case GET_WAREHOUSE_ERROR:
      case CREATE_WAREHOUSE_ERROR:
      case UPDATE_WAREHOUSE_ERROR:
      case CHANGE_STATUS_WAREHOUSE_ERROR:
      case DELETE_WAREHOUSE_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default warehouses;



// WEBPACK FOOTER //
// ./src/reducers/warehouses.js